import React, { Component } from 'react';

class FooterAppLinks extends Component {
  constructor(props) {
    super(props);
  }

  getFooterAppLinksHTML() {
    const items = this.props.data.items;
    let html = items.map((item, index) =>
      <a key={index} href={item.href}><img className="social-icon" loading='lazy' src={item.src} alt={item.alt} /></a>
    );

    return (
      <div className="social-container">
        {html}
      </div>
    );
  }

  render() {
    return (
      <div className="row">
        <div className="col-xs-12 col-download-app">
          <h2 className="footer-item-header">{this.props.data.title}</h2>
          {this.getFooterAppLinksHTML()}
        </div>
      </div>
    )
  }
}

export default FooterAppLinks;